export const KenBurns = ({ src, alt = "", className = "", imgClassName = "" }) => (
  <div className={`overflow-hidden ${className}`}>
    <img src={src} alt={alt} className={`kenburns h-full w-full object-cover ${imgClassName}`} />
  </div>
);
